import { useState } from "react";
import { motion } from "framer-motion";
import Navigation from "@/components/landing/Navigation";
import HeroSection from "@/components/landing/HeroSection";
import PainSection from "@/components/landing/PainSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import ValueSection from "@/components/landing/ValueSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import BenefitsSection from "@/components/landing/BenefitsSection";
import PricingSection from "@/components/landing/PricingSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import EmailSignupModal from "@/components/landing/EmailSignupModal";
import { ArrowUp } from "lucide-react";

const LandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Handle scroll to show/hide scroll-to-top button
  if (typeof window !== "undefined") {
    window.addEventListener("scroll", () => {
      setShowScrollTop(window.scrollY > 500);
    });
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="landing-page">
      <Navigation onOpenModal={() => setIsModalOpen(true)} />
      
      <main>
        <HeroSection onOpenModal={() => setIsModalOpen(true)} />
        <PainSection />
        <HowItWorksSection />
        <ValueSection />
        <FeaturesSection />
        <BenefitsSection />
        <PricingSection onOpenModal={() => setIsModalOpen(true)} />
        <TestimonialsSection />
        <ContactSection />
      </main>

      <Footer />

      {/* Email Signup Modal */}
      <EmailSignupModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          onClick={scrollToTop}
          className="scroll-top"
          data-testid="scroll-to-top-btn"
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-5 h-5" />
        </motion.button>
      )}
    </div>
  );
};

export default LandingPage;
